
    import {
      getAllStudents,
      createStudent,
      createAllStudents,
      updateStudent,
      deleteStudent
    } from "@/services/student";

    const state = {
      students: [],
      params: {activeOnly: true, requirementStatus: "All"},
      processed: false
    };

    const getters = {
      getStudents(state) {
        return state.students;
      },
      getParams(state) {
        return state.params;
      },
      studentProcessed(state){
        return state.processed;
      }
    };

    const actions = {
      setParams({ commit }, params){
        commit("SET_PARAMS", params);
      },
      fetchStudents({ commit }, params) {
          commit("SET_PROCESSING");
          return new Promise((resolve, reject) => {
            getAllStudents(
              params
            )
              .then(response => {
                commit("SET_STUDENTS", response.data);
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createStudent({ commit }, student) {
          return new Promise((resolve, reject) => {
            createStudent(student)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        createAllStudents({ commit }, students) {
          return new Promise((resolve, reject) => {
            createAllStudents(students)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        updateStudent({ commit }, student) {
          return new Promise((resolve, reject) => {
            updateStudent(student)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        },
        deleteStudent({ commit }, id) {
          return new Promise((resolve, reject) => {
            deleteStudent(id)
              .then(response => {
                commit("SET_PROCESSED");
                resolve(response.data);
              })
              .catch(error => {
                reject(error);
              });
          });
        }
      };

    const mutations = {
      SET_STUDENTS(state, data) {
        state.students = data;
        state.processed = true;
      },
      SET_PARAMS(state, data) {
        state.params = data;
      },
      SET_PROCESSING(state) {
        state.processed = false;
      },
      SET_PROCESSED(state) {
        state.processed = true;
      }
    };

    export default {
      state,
      getters,
      actions,
      mutations
    };
    